import { CdkMenu, CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { Component, computed, input, model, viewChild } from "@angular/core";
import { BaseConfig } from "../../common/config/config.adapter";
import { Align } from "../../common/types";
import { Menu } from "../../menu/menu.component";
import { MenuOption } from "../../menu/option/menu-option.component";
import { ColumnDefinition } from "../types/colum-definition.type";
import { CheckboxColumn } from "./checkbox/checkbox-column.component";
import { Input } from "../../input/input.component";
import { Divider } from "../../divider/divider.component";
import { Select } from "../../select/select.component";

@Component({
    host: {
        ngSkipHydration: "true",
    },
    selector: "[gridColumn]",
    templateUrl: "./column.component.html",
    styleUrls: [
        "../view/table/table.component.scss",
        "./column.component.scss",
    ],
    imports: [
        CheckboxColumn,
        CdkMenuModule,
        Menu,
        MenuOption,
        CommonModule,
        Input,
        Divider,
        Select,
    ],
    standalone: true,
})
export class GridColumn extends BaseConfig {
    menu = viewChild(CdkMenu);

    showHeaderOption = input<boolean>(true);
    column = input.required<ColumnDefinition>();
    orderBy = model<string | null>(null);
    groupBy = model<string | null>(null);
    align = model<Align>("desc");
    filters = model<{ [key: string]: any }>({});
    selecteds = model<any[]>([]);

    filterOptions = computed(() => {
        const column = this.column();
        if (column.type === "enum" || column.type === "boolean") {
            const props = column.badgeProps as any;
            return Object.keys(props).map((key) => ({
                label: props[key].text,
                value: key,
            }));
        }
        return [];
    });

    handleFilter(value: any) {
        const filters = { ...this.filters() };
        if (value === null || value === undefined || value === "") {
            delete filters[this.column().field];
        } else {
            filters[this.column().field] = value;
        }
        this.filters.set(filters);
    }

    handleGroupBy() {
        if (this.groupBy() === this.column().field) {
            this.groupBy.set(null);
        } else {
            this.groupBy.set(this.column().field);
        }
    }

    handleOrderBy(align: Align) {
        this.align.set(align);
        this.orderBy.set(this.column().alias || this.column().field);
    }
}
